import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Wrapper from './styles';
import { PageHero } from '../../components';
import { useUserContext } from '../../context/user_context';
import { Link } from 'react-router-dom';
import { useCartContext } from '../../context/cart_context';
import { useProductsContext } from '../../context/products_context';
import Button from '../../components/Button';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';

function UpdatePasswordPage() {
  const {
    currentUser: { displayName, photoURL },
    logoutUser,
    updateUserProfileImage,
    updateUserProfileName,
    uploadProfileImage,
    updateUserProfilePassword,
    reauthenticateUser,
    updateUserDetails
  } = useUserContext();
  const { clearCart } = useCartContext();
  const { closeSidebar } = useProductsContext();
  const [image, setImage] = useState(photoURL);
  const [name, setName] = useState(displayName || 'USER');
  const [exisitingPassword, setExistingPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isVisibleCurrentPassword, setIsVisibleCurrentPassword] =
    useState(false);
  const [isVisibleNewPassword, setIsVisibleNewPassword] = useState(false);
  const [isVisibleConfirmPassword, setIsVisibleConfirmPassword] =
    useState(false);

  const handleImage = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
      handleImageUpload(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleImageUpload = async (image) => {
    setLoading(true);
    const response_1 = await uploadProfileImage(image);
    if (response_1.success) {
      const { url } = response_1.data;
      try {
        // eslint-disable-next-line
        const response_2 = await updateUserProfileImage(url);
        toast.success('Profile image changed successfully');
      } catch (error) {
        setLoading(false);
        toast.error(`Error: ${error.message}`);
      }
    } else {
      const { message } = response_1;
      toast.error(`Error: ${message}`);
    }
    setLoading(false);
  };

  const handleSubmitName = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // eslint-disable-next-line
      const response_2 = await updateUserProfileName(name);
      toast.success('Profile name changed successfully');
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
    setLoading(false);
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // eslint-disable-next-line
      if (newPassword.length < 6) {
        return toast.error('Password should be atleast 6 characters');
      }
      if (newPassword !== confirmNewPassword) {
        return toast.error('Passwords do not match');
      }


      // eslint-disable-next-line
      const response_3 = await updateUserDetails("password", confirmNewPassword,exisitingPassword);
      if(response_3.success){
        toast.success('Profile password changed successfully');
      }
      else{
        toast.error(`${response_3.message}`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    document.title = 'Mukunda Jewelery | Profile';
  }, []);

  return (
    <Wrapper>
      <PageHero title='Update Password' />
      <div className='seperator'>
        <hr />
        <span>Password</span>
      </div>
      <form onSubmit={handleSubmitPassword}>
        <div className='form-control password rounded-md border border-[#A1A1AA]'>
          <input
            type={isVisibleCurrentPassword ? 'text' : 'password'}
            name='password'
            className='input'
            placeholder='Current password'
            value={exisitingPassword}
            onChange={(e) => setExistingPassword(e.target.value)}
          />
          <div
            className='togglebtn'
            onClick={(e) =>
              setIsVisibleCurrentPassword(!isVisibleCurrentPassword)
            }
          >
            {!isVisibleCurrentPassword ? (
              <BsFillEyeSlashFill />
            ) : (
              <BsFillEyeFill />
            )}
          </div>
        </div>
        <div className='form-control password rounded-md border border-[#A1A1AA]'>
          <input
            type={isVisibleNewPassword ? 'text' : 'password'}
            name='password'
            className='input'
            placeholder='New password'
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <div
            className='togglebtn'
            onClick={(e) => setIsVisibleNewPassword(!isVisibleNewPassword)}
          >
            {!isVisibleNewPassword ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
          </div>
        </div>
        <div className='form-control password rounded-md border border-[#A1A1AA]'>
          <input
            type={isVisibleConfirmPassword ? 'text' : 'password'}
            name='password'
            className='input'
            placeholder='Confirm new password'
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
          <div
            className='togglebtn '
            onClick={(e) =>
              setIsVisibleConfirmPassword(!isVisibleConfirmPassword)
            }
          >
            {!isVisibleConfirmPassword ? (
              <BsFillEyeSlashFill />
            ) : (
              <BsFillEyeFill />
            )}
          </div>
        </div>
        <Button
          disabled={loading}
          type='submit'
          className='btn submit-btn rounded-md'
          style={{ backgroundColor: '#d3a143' }}
        >
          change password
        </Button>
      </form>
      <div className='seperator'>
        <hr />
      </div>
    </Wrapper>
  );
}

export default UpdatePasswordPage;
